import { render, staticRenderFns } from "./AmountConvenioChart.vue?vue&type=template&id=0c0360d5&scoped=true&"
import script from "./AmountConvenioChart.vue?vue&type=script&lang=js&"
export * from "./AmountConvenioChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0360d5",
  null
  
)

export default component.exports